/* MXDVS add to cart effects, assets/mxdvs-atc-fx.js (29.09.2026). Used by sections/mxdvs-product.liquid. */
/* Add to cart effects (termbeam is the chosen one). MxAtcFx.run(kind, { layer, img, btn, cart, label, done })
   layer: a full-size overlay (position:fixed in the theme, pointer-events:none)
   img:   the product photo on screen (or null), btn: the add to cart button,
   cart:  the header cart icon, label: "+1 NAME / SIZE", done: called when it lands.
   Everything animates transform and opacity only. */
window.MxAtcFx = (() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rel = (el, L) => { const r = el.getBoundingClientRect(), b = L.getBoundingClientRect(); return { x: r.left - b.left, y: r.top - b.top, w: r.width, h: r.height }; };
  const center = r => ({ x: r.x + r.w / 2, y: r.y + r.h / 2 });
  const mk = (L, css) => { const d = document.createElement('div'); d.style.cssText = 'position:absolute;pointer-events:none;' + css; L.appendChild(d); return d; };
  const imgSrc = el => el && el.tagName === 'IMG' ? el.currentSrc || el.src : null;

  /* Where it flies from: the part of the photo you can see (r), or a thumbnail spot above the button.
     full keeps the whole photo box so strips and tiles line up with the image. */
  function source(o) {
    const L = o.layer, lb = L.getBoundingClientRect();
    if (o.img) {
      const f = rel(o.img, L), top = Math.max(f.y, 0), bot = Math.min(f.y + f.h, lb.height);
      if (bot - top > 60) return { r: { x: f.x, y: top, w: f.w, h: bot - top }, full: f, real: true };
    }
    const b = rel(o.btn, L), r = { x: b.x + b.w / 2 - 60, y: b.y - 140, w: 120, h: 126 };
    return { r, full: r, real: false };
  }
  function hideReal(o, on) { if (o.img) { o.img.style.transition = 'opacity .35s'; o.img.style.opacity = on ? '0' : ''; } }

  /* 1. Genie: the photo is cut in strips that stream into the cart one after the other,
        the side nearest the cart first, pinching as they go, like the genie into his lamp */
  function genie(o, src, t) {
    const L = o.layer, url = imgSrc(o.img), N = 22, r = src.full, sh = r.h / N, up = t.y < r.y;
    if (src.real) hideReal(o, true);
    let left = N;
    for (let i = 0; i < N; i++) {
      const d = mk(L, 'left:' + r.x + 'px;top:' + (r.y + i * sh) + 'px;width:' + r.w + 'px;height:' + (sh + 1.2) + 'px;' + (url ? 'background:var(--fx-img) 0 ' + (-i * sh) + 'px / ' + r.w + 'px ' + r.h + 'px no-repeat #fff;' : 'background:#111;'));
      const cx = r.x + r.w / 2, cy = r.y + i * sh + sh / 2, dx = t.x - cx, dy = t.y - cy;
      const k = up ? i : N - 1 - i;
      d.animate([
        { transform: 'translate(0,0) scale(1,1)', opacity: 1 },
        { offset: 0.45, transform: 'translate(' + dx * 0.55 + 'px,' + dy * 0.18 + 'px) scale(.42,1)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.03,.3)', opacity: 0.15 }
      ], { duration: 640, delay: k / N * 420, easing: 'cubic-bezier(.55,0,.8,.45)', fill: 'forwards' }).onfinish = () => { d.remove(); if (--left === 0) { o.done(); if (src.real) setTimeout(() => hideReal(o, false), 250); } };
    }
  }

  /* 2. Pixel stream: the photo breaks into tiles that pour into the cart, nearest first */
  function pixels(o, src, t) {
    const L = o.layer, url = imgSrc(o.img), G = 10, r = src.full, tw = r.w / G, th = r.h / G;
    if (src.real) hideReal(o, true);
    const tiles = [];
    for (let y = 0; y < G; y++) for (let x = 0; x < G; x++) {
      const cx = r.x + x * tw + tw / 2, cy = r.y + y * th + th / 2;
      tiles.push({ x, y, cx, cy, d: Math.hypot(t.x - cx, t.y - cy) });
    }
    const dmin = Math.min(...tiles.map(q => q.d)), dmax = Math.max(...tiles.map(q => q.d));
    let left = tiles.length;
    tiles.forEach(q => {
      const el = mk(L, 'left:' + (r.x + q.x * tw) + 'px;top:' + (r.y + q.y * th) + 'px;width:' + (tw + 0.5) + 'px;height:' + (th + 0.5) + 'px;' + (url ? 'background:var(--fx-img) ' + (-q.x * tw) + 'px ' + (-q.y * th) + 'px / ' + r.w + 'px ' + r.h + 'px no-repeat #fff;' : 'background:#111;'));
      const dx = t.x - q.cx, dy = t.y - q.cy, mx = (Math.random() - 0.5) * 70, my = -Math.random() * 60;
      el.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
        { offset: 0.5, transform: 'translate(' + (dx * 0.5 + mx) + 'px,' + (dy * 0.5 + my) + 'px) scale(.6) rotate(' + (Math.random() * 90 - 45) + 'deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(0deg)', opacity: 0 }
      ], { duration: 700, delay: (q.d - dmin) / (dmax - dmin || 1) * 380 + Math.random() * 90, easing: 'cubic-bezier(.6,0,.4,1)', fill: 'forwards' }).onfinish = () => { el.remove(); if (--left === 0) { o.done(); if (src.real) setTimeout(() => hideReal(o, false), 250); } };
    });
  }

  /* 3. Arc toss: a small copy of the photo is thrown in an arc into the cart */
  function arc(o, src, t) {
    const L = o.layer, url = imgSrc(o.img), c = center(src.r), S = 90;
    const el = mk(L, 'left:' + (c.x - S / 2) + 'px;top:' + (c.y - S / 2) + 'px;width:' + S + 'px;height:' + S + 'px;border-radius:5px;box-shadow:0 8.5px 17.5px rgba(0,0,0,.15);' + (url ? 'background:#fff var(--fx-img) center / contain no-repeat;' : 'background:#111;'));
    const p1 = { x: (c.x + t.x) / 2, y: Math.min(c.y, t.y) - 120 }, frames = [];
    for (let i = 0; i <= 16; i++) {
      const u = i / 16, e = u * u * (3 - 2 * u), a = 1 - e;
      const x = a * a * c.x + 2 * a * e * p1.x + e * e * t.x, y = a * a * c.y + 2 * a * e * p1.y + e * e * t.y;
      frames.push({ transform: 'translate(' + (x - c.x) + 'px,' + (y - c.y) + 'px) scale(' + (1 - 0.85 * e) + ') rotate(' + (-30 * e) + 'deg)', opacity: i === 16 ? 0.2 : 1 });
    }
    el.animate(frames, { duration: 760, easing: 'linear', fill: 'forwards' }).onfinish = () => { el.remove(); o.done(); };
  }

  /* 4. Terminal line: "+1 NAME / SIZE" types above the button, then drops into the cart */
  function terminal(o, src, t) {
    const L = o.layer, b = rel(o.btn, L), txt = o.label || '+1 ITEM';
    const el = mk(L, 'left:' + (b.x + b.w / 2) + 'px;top:' + (b.y - 35) + 'px;transform:translateX(-50%);padding:0 8.5px;border-radius:5px;background:#111;color:#fff;font:700 11px/26px "Roboto Mono",ui-monospace,monospace;white-space:nowrap;');
    const out = document.createElement('span'), cur = document.createElement('span');
    cur.style.cssText = 'display:inline-block;width:.6em;height:1em;background:#fff;vertical-align:-.15em;margin-left:2px';
    el.append(out, cur);
    let i = 0;
    const type = () => {
      if (i <= txt.length) { out.textContent = txt.slice(0, i++); setTimeout(type, 14 + Math.random() * 26); return; }
      setTimeout(() => {
        cur.remove(); const e = rel(el, L), dx = t.x - (e.x + e.w / 2), dy = t.y - (e.y + e.h / 2);
        el.animate([{ transform: 'translateX(-50%)', opacity: 1 }, { transform: 'translateX(-50%) translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.1 }], { duration: 520, easing: 'cubic-bezier(.6,0,.9,.4)', fill: 'forwards' }).onfinish = () => { el.remove(); o.done(); };
      }, 380);
    };
    type();
  }

  /* 5. Light beam: a scan line reads the photo, a beam shoots to the cart, the cart pulses */
  function beam(o, src, t) {
    const L = o.layer, r = src.r, c = center(r);
    const scan = mk(L, 'left:' + r.x + 'px;top:' + r.y + 'px;width:' + r.w + 'px;height:2px;background:#111;box-shadow:0 0 12px 2px rgba(0,0,0,.35);');
    scan.animate([{ transform: 'translateY(0)', opacity: 0 }, { offset: .15, opacity: 1 }, { transform: 'translateY(' + r.h + 'px)', opacity: 0 }], { duration: 420, easing: 'ease-in-out', fill: 'forwards' }).onfinish = () => {
      scan.remove();
      const dx = t.x - c.x, dy = t.y - c.y, len = Math.hypot(dx, dy), ang = Math.atan2(dy, dx) * 180 / Math.PI;
      const ln = mk(L, 'left:' + c.x + 'px;top:' + c.y + 'px;width:' + len + 'px;height:1px;transform-origin:0 50%;transform:rotate(' + ang + 'deg) scaleX(0);background:linear-gradient(90deg,rgba(0,0,0,0),#111);');
      const dot = mk(L, 'left:' + (c.x - 3) + 'px;top:' + (c.y - 3) + 'px;width:6px;height:6px;border-radius:50%;background:#ff1a1a;box-shadow:0 0 8px #ff1a1a;');
      ln.animate([{ transform: 'rotate(' + ang + 'deg) scaleX(0)' }, { transform: 'rotate(' + ang + 'deg) scaleX(1)' }], { duration: 200, easing: 'ease-out', fill: 'forwards' });
      dot.animate([{ transform: 'translate(0,0)' }, { transform: 'translate(' + dx + 'px,' + dy + 'px)' }], { duration: 420, delay: 120, easing: 'cubic-bezier(.5,0,.2,1)', fill: 'forwards' }).onfinish = () => {
        dot.remove(); ln.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards' }).onfinish = () => ln.remove();
        for (let k = 0; k < 2; k++) {
          const ring = mk(L, 'left:' + (t.x - 17.5) + 'px;top:' + (t.y - 17.5) + 'px;width:35px;height:35px;border-radius:50%;border:1px solid #111;');
          ring.animate([{ transform: 'scale(.2)', opacity: 0.7 }, { transform: 'scale(1.8)', opacity: 0 }], { duration: 700, delay: k * 220, easing: 'cubic-bezier(.33,0,.25,1)', fill: 'forwards' }).onfinish = () => ring.remove();
        }
        o.done();
      };
    };
  }

  /* Terminal + beam: the photo is scanned while "+1 NAME / SIZE" types above the button,
     then a beam shoots from the centre of the photo to the cart, a red dot runs along it and the cart pulses.
     The bubble just fades; it has no line of its own. */
  function termbeam(o, src, t) {
    const L = o.layer, b = rel(o.btn, L), txt = o.label || '+1 ITEM';
    if (src.real) {
      const r = src.r, scan = mk(L, 'left:' + r.x + 'px;top:' + r.y + 'px;width:' + r.w + 'px;height:2px;background:#111;box-shadow:0 0 12px 2px rgba(0,0,0,.35);');
      scan.animate([{ transform: 'translateY(0)', opacity: 0 }, { offset: .15, opacity: 1 }, { transform: 'translateY(' + r.h + 'px)', opacity: 0 }], { duration: 520, easing: 'ease-in-out', fill: 'forwards' }).onfinish = () => scan.remove();
    }
    const el = mk(L, 'left:' + (b.x + b.w / 2) + 'px;top:' + (b.y - 35) + 'px;transform:translateX(-50%);padding:0 8.5px;border-radius:5px;background:#111;color:#fff;font:700 11px/26px "Roboto Mono",ui-monospace,monospace;white-space:nowrap;');
    const out = document.createElement('span'), cur = document.createElement('span');
    cur.style.cssText = 'display:inline-block;width:.6em;height:1em;background:#fff;vertical-align:-.15em;margin-left:2px';
    el.append(out, cur);
    let i = 0;
    const type = () => {
      if (i <= txt.length) { out.textContent = txt.slice(0, i++); setTimeout(type, 14 + Math.random() * 26); return; }
      setTimeout(() => {
        cur.remove();
        /* The beam starts in the centre of the photo (or of the thumbnail spot above the button) */
        const c = center(src.r), dx = t.x - c.x, dy = t.y - c.y, len = Math.hypot(dx, dy), ang = Math.atan2(dy, dx) * 180 / Math.PI;
        const ln = mk(L, 'left:' + c.x + 'px;top:' + c.y + 'px;width:' + len + 'px;height:1px;transform-origin:0 50%;transform:rotate(' + ang + 'deg) scaleX(0);background:linear-gradient(90deg,rgba(0,0,0,.15),#111);');
        const dot = mk(L, 'left:' + (c.x - 3) + 'px;top:' + (c.y - 3) + 'px;width:6px;height:6px;border-radius:50%;background:#ff1a1a;box-shadow:0 0 8px #ff1a1a;');
        ln.animate([{ transform: 'rotate(' + ang + 'deg) scaleX(0)' }, { transform: 'rotate(' + ang + 'deg) scaleX(1)' }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
        dot.animate([{ transform: 'translate(0,0)' }, { transform: 'translate(' + dx + 'px,' + dy + 'px)' }], { duration: 460, delay: 140, easing: 'cubic-bezier(.5,0,.2,1)', fill: 'forwards' }).onfinish = () => {
          dot.remove();
          ln.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards' }).onfinish = () => ln.remove();
          el.animate([{ opacity: 1 }, { opacity: 0, transform: 'translateX(-50%) translateY(-8.5px)' }], { duration: 300, fill: 'forwards' }).onfinish = () => el.remove();
          for (let k = 0; k < 2; k++) {
            const ring = mk(L, 'left:' + (t.x - 17.5) + 'px;top:' + (t.y - 17.5) + 'px;width:35px;height:35px;border-radius:50%;border:1px solid #111;');
            ring.animate([{ transform: 'scale(.2)', opacity: 0.7 }, { transform: 'scale(1.8)', opacity: 0 }], { duration: 700, delay: k * 220, easing: 'cubic-bezier(.33,0,.25,1)', fill: 'forwards' }).onfinish = () => ring.remove();
          }
          o.done();
        };
      }, 300);
    };
    type();
  }

  const KINDS = { termbeam, genie, pixels, arc, terminal, beam };
  function run(kind, o) {
    const t = center(rel(o.cart, o.layer)), src = source(o), url = imgSrc(o.img);
    /* The photo is set once on the layer; every strip or tile points at it */
    if (url) o.layer.style.setProperty('--fx-img', 'url("' + url + '")');
    if (RM || !KINDS[kind]) { o.done(); return; }
    KINDS[kind](o, src, t);
  }
  return { run, KINDS: Object.keys(KINDS) };
})();
